module.exports = __webpack_public_path__ + "static/media/hi.dc2124af.svg";